/* eslint-disable no-param-reassign */
import produce from 'immer';
var cellSetsError = produce(function (draft, action) {
  var error = action.payload.error;
  draft.loading = false;
  draft.error = error !== null && error !== void 0 ? error : true;
});
export default cellSetsError;